import React from "react";
import { Helmet } from "react-helmet-async";

export function Seo({ title, description, image, path }) {
  const siteName = "Farniymart Fashion";
  const fullTitle = title ? `${title} — ${siteName}` : `${siteName} — Luxury Fashion for Women & Men`;
  const desc = description || "Modern silhouettes. Refined essentials. Curated luxury fashion collections for women and men.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      {image && <meta property="og:image" content={image} />}
      {path && <meta property="og:url" content={`https://farniymart.shop${path}`} />}
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}
